<nav class="sidebar-view">
  <!--stickyHeader
  [customDirectionHandler]="directionHandler$"
  (onPageYOffsetEvent)="onPageYOffsetEvent($event)"-->

  <!--<button class="sidebar__toggle" (click)="isOpen = !isOpen; onSibarOpenEvent.emit(isOpen)">
    <i class="fa fa-bars" aria-hidden="true"></i>
  </button>-->

  <ul>
    <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: false }">
      <a [routerLink]="['/dashboard']" title="Home">
        <i class="fal fa-fw fa-home"></i>
        <span class="sidebar-link-text">Home</span>
      </a>
    </li>

    <ng-container *ngIf="isLoggedIn">
      <li [routerLinkActive]="['active']">
        <a [routerLink]="['/find-vehicles']" title="Find Vehicle">
          <i class="fal fa-fw fa-search"></i>
          <span class="sidebar-link-text">Find Vehicle</span>
        </a>
      </li>
      <li [routerLinkActive]="['active']">
        <a [routerLink]="['/baskets/basket-list']" title="Baskets">
          <i class="fal fa-fw fa-layer-group"></i>
          <span class="sidebar-link-text">Baskets</span>
        </a>
      </li>
      <li [routerLinkActive]="['active']">
        <a [routerLink]="['/reports']" title="Reports">
          <!--<i class="fal fa-fw fa-layer-group"></i>-->
          <i class="fal fa-fw fa-clipboard-list"></i>
          <span class="sidebar-link-text">Reports</span>
        </a>
      </li>
    </ng-container>

    <!-- Admin -->
    <ng-container *ngIf="isLoggedIn && (isAdmin$ | async)">
      <li class="sidebar-new-section"
          [routerLinkActive]="['active']">
        <a [routerLink]="['/admin']" title="Admin Menu">
          <i class="fas fa-user-cog"></i>
          <span class="sidebar-link-text">Admin Menu</span>
        </a>
      </li>
    </ng-container>

    <!-- Dev start -->
    <ng-container *ngIf="isLoggedIn && isDevTest">
      <li class="sidebar-new-section"
          [routerLinkActive]="['active']">
        <a [routerLink]="['/fetch-data']" title="Restricted">
          <i class="fa fa-fw fa-plus-circle"></i>
          <span class="sidebar-link-text">Restricted</span>
        </a>
      </li>
      <li>
        <a href="https://bootstrap.cap-hpi.com/v3" target="_blank" rel="noopener" title="cap hpi bootstrap V3 Template">
          <i class="fa fa-fw fa-list"></i>
          <span class="sidebar-link-text">bs Template</span>
        </a>
      </li>
      <li>
        <a href="https://bootstrap.cap-hpi.com/v3/default/Demo/LayoutComplete" target="_blank" rel="noopener" title="cap hpi bootstrap V3 Demo">
          <i class="fa fa-fw fa-list"></i>
          <span class="sidebar-link-text">Demo</span>
        </a>
      </li>
      <li [routerLinkActive]="['active']">
        <a [routerLink]="['/sample-page']" title="Sample page">
          <i class="fa fa-fw fa-home"></i>
          <span class="sidebar-link-text">Sample page</span>
        </a>
      </li>
      <li [routerLinkActive]="['active']">
        <a [routerLink]="['/highcharts']" title="Highcharts">
          <i class="fa fa-fw fa-home"></i>
          <span class="sidebar-link-text">Highcharts</span>
        </a>
      </li>
    </ng-container>
    <!-- Dev end -->



    <!-- Dev start -->
    <li *ngIf="isDevDebug"
        class="sidebar-new-section">
      <a (click)="downloadTest()">
        <i class="fas fa-download"></i>
        <span class="sidebar-link-text">download</span>
      </a>
    </li>
    <li *ngIf="isDevDebug && debugData"
        class="sidebar-new-section" style="color:yellow;line-height: 1;">
      <div>{{debugData | json}}</div>
    </li>
    <!-- Dev end -->

  </ul>

  <div class="sidebar-bottom">

    <ul>
      <li class="sidebar-new-section" *ngIf="isLoggedIn"
          [routerLinkActive]="['active']">
        <a [routerLink]="['/admin']" title="Settings">
          <i class="fal fa-cog"></i>
          <span class="sidebar-link-text">Settings</span>
        </a>
      </li>
      <li>
        <a href="https://cap-hpi-valuations.zendesk.com/hc/en-us/categories/360000875338-Residual-Value-Tracker" target="_blank">
          <i class="fal fa-question"></i>
          <span class="sidebar-link-text">Help & FAQs</span>
        </a>
      </li>
      <li *ngIf="!isLoggedIn && useIdentityServer"
          [routerLinkActive]="['active']">
        <a (click)="login()">
          <i class="fal fa-sign-in"></i>
          <span class="sidebar-link-text">Sign In</span>
        </a>
      </li>
      <li *ngIf="isLoggedIn"
          [routerLinkActive]="['active']">
        <a [routerLink]="['/privacyNotice']">
          <i class="fal fa-file-alt"></i>
          <span class="sidebar-link-text">Privacy Notice</span>
        </a>
      </li>
      <li *ngIf="isLoggedIn && useIdentityServer"
          [routerLinkActive]="['active']">
        <a (click)="logout()">
          <i class="fal fa-sign-out"></i>
          <span class="sidebar-link-text">Sign Out</span>
        </a>
      </li>
    </ul>

  </div>
</nav>
